import * as React from 'react';
import type { UrlDataSourceEnumControlProps } from '@web-config-app/entity-form';
import { useUrlDataSource } from '@web-config-app/entity-form';
import { SelectInputControl } from '../../select-input-control/select-input-control.component';

export const UrlDataSourceEnumControl: React.FC<
  UrlDataSourceEnumControlProps
> = ({ dataSource, dataSourceConsumer, ...props }) => {
  const { data, ...queryProps } = useUrlDataSource({
    dataSource,
    dataSourceConsumer,
  });

  const enumOptions =
    data && typeof data === 'object' && 'enumOptions' in data
      ? data.enumOptions
      : [];

  if (enumOptions.length === 0) {
    // eslint-disable-next-line no-console
    console.error(
      'UrlDataSourceEnumControl: No enumOptions found in data source.',
    );
  }

  return (
    <SelectInputControl
      {...props}
      enumOptions={enumOptions}
      loading={queryProps.isLoading}
    />
  );
};
